import * as React from "react";

import {
  Box,
  Container,
  Grid,
  Header,
  Link,
  SpaceBetween,
} from "@amzn/awsui-components-react";
import { Funding } from "../../../calcBusterTypes";
import AnnualRunRateBarChart from "./AnnualRunRateBarChart";
import config from "../../../config";

const ArrTab: React.FC<{ funding: Funding }> = ({ funding }) => {
  return (
    <Container header={<Header>Annual Run Rate</Header>}>
      <Grid
        gridDefinition={[
          { colspan: 1 },
          { colspan: 4 },
          { colspan: 1 },
          { colspan: 4 },
          { colspan: 1 },
        ]}
      >
        <Box />
        {AnnualRunRateBarChart(funding)}
        <Box />
        <Box margin="l">
          <SpaceBetween size="s">
            <li>
              <b>Qualification ARR</b>: Steady State Annual Run Rate (optimized)
              valid for funding
            </li>
            <li>
              <b>MAP Eligible ARR</b>: Annual Run Rate generated by all the{" "}
              <Link href={config.MAP_ELIGIBLE_LIST}>eligible services</Link>
            </li>
            <li>
              <b>Modernization ARR</b>: Annual Run Rate generated by{" "}
              <Link href={config.MODERN_SERVICES_LIST}>modern services</Link>
            </li>
            <li>
              <b>SAP and Oracle Eligible ARR</b>: Annual Run Rate generated by
              all the SAP and Oracle{" "}
              <Link href={config.MAP_ELIGIBLE_LIST}>eligible services</Link>
            </li>
            <li>
              <b>DB and Analytics Eligible ARR</b>: Annual Run Rate generated by
              all the DB and Analytics{" "}
              <Link href={config.MAP_ELIGIBLE_LIST}>eligible services</Link>
            </li>
          </SpaceBetween>
        </Box>
        <Box />
      </Grid>
    </Container>
  );
};

export default ArrTab;
